import Asset from './Asset';

export default class Fontasset extends Asset {
    constructor(assetManager) {
        super(assetManager);
        this.type = 'FONT';

        this.font = null;
    }

    load(id, url, onLoad, onError) {
        this.id = id;

        const self = this;
        const internalOnLoad = function() {
            self.loaded = true;

            if (onLoad) onLoad(self);
        };
        const internalOnError = function(error) {
            if (onError)
                onError({
                    msg: error
                });
            else throw error;
        };

        try {
            this.font = new FontFace(this.id.replace('.', '_'), `url(${url})`);
            this.font
                .load()
                .then(function(loaded_face) {
                    document.fonts.add(loaded_face);
                    internalOnLoad();
                })
                .catch(function(error) {
                    internalOnError(error);
                });
        } catch {
            const newStyle = document.createElement('style');
            newStyle.appendChild(
                document.createTextNode(`\
@font-face {\
    font-family: ${this.id.replace('.', '_')};\
    src: url('${url}'); format('ttf');\
}`)
            );
            document.head.appendChild(newStyle);
            const preloadCanvas = document.createElement('canvas');
            const ctx = preloadCanvas.getContext('2d');
            ctx.font = `10px ${this.id.replace('.', '_')}`;
            ctx.fillText('Text Preloader', 0, 0);
            console.warn("FontFace is not supported on this browser. Can't verify wether or not font will be loaded.");
            internalOnLoad();
        }
    }

    get() {
        return this.font;
    }
}
